export const initialAboutState = {
    loading: false,
    error: null,
    dataAbout: null,
};
